import axios from 'axios';

export const API_URL = process.env.VUE_APP_SERVER_URL ? process.env.VUE_APP_SERVER_URL : 'https://croinc.bearle.ru';

function catchError(error, cb) {
  const sep = '\r\n';
  if (error.response !== undefined && error.response.status === 400) {
    if (typeof error.response.data === 'object') {
      let err = isErrorObject(error.response.data, sep).join(sep);
      return cb(new Error(err));
    }
    cb(new Error(error.response.data));
  } else if (cb && error && error.message) {
    cb(new Error(error.message));
  }
}

function isErrorObject(data, sep) {
  return Object.keys(data).map(k => {
    if (data[k].length) return data[k].join(sep);
    return [...isErrorObject(data[k], sep)];
  });
}

function validateSomething(url, value, callback) {
  axios.post(url, value).then(
    response => callback()
  ).catch(error => catchError(error, callback));
}

export default {
  methods: {
    validateEmail(rule, value, callback) {
      validateSomething(`${API_URL}/api/v1/admin/autocomplete/validate/email/`, value, callback);
    },

    validateSlug(rule, value, callback) {
      validateSomething(`${API_URL}/api/v1/admin/autocomplete/validate/slug/`, value, callback);
    },

    validatePhone(rule, value, callback) {
      validateSomething(`${API_URL}/api/v1/admin/autocomplete/validate/phone/`, {phone: value}, callback);
    },
    validateUsername(rule, value, callback) {
      validateSomething(`${API_URL}/api/v1/admin/autocomplete/validate/username/`, {username: value}, callback);
    }

  }
};
